import { localeOf } from "../services/i18ln/format";

/** Formats a Stripe amount (in the smallest currency unit, e.g. cents) in the app's language. */
export const formatMoney = (amount: number, currency: string | undefined, language: string) =>
  new Intl.NumberFormat(localeOf(language), {
    style: "currency",
    currency: (currency || "brl").toUpperCase(),
  }).format(amount / 100);
